import React from 'react';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';

const Root = styled.div`
	display: block;
`;

const PersonRoot = styled.div`
	position: relative;
	display: flex;
	align-items: center;
`;

const PersonDetails = styled.div`
	flex-shrink: 1;
	display: flex;
	flex-direction: column;
	line-height: 1.4;
	margin-left: 1em;
	overflow: hidden;
`;

const Line1 = styled.div`
	font-size: 14px;
	font-weight: 500;
`;

const Line2 = styled.div`
	font-size: 12px;
	font-weight: 300;
`;

const PersonLoadingTemplate = (props) => {
	return (
		<Root className={props.styleName ? props.styleName : ''}>
			<PersonRoot>
				<Skeleton circle height={50} width={50} />
				<PersonDetails>
					<Line1>
						<Skeleton width={100} />
					</Line1>
					<Line2>
						<Skeleton width={150} />
					</Line2>
				</PersonDetails>
			</PersonRoot>
		</Root>
	);
};

export default PersonLoadingTemplate;
